import { createRouter, createWebHistory } from 'vue-router'
import AppLayout from '@/components/layout/AppLayout.vue'
import { canViewModule } from '@/utils/permission'
import { ElMessage } from 'element-plus'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: '登录',
      hideInMenu: true
    }
  },
  {
    path: '/',
    component: AppLayout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: {
          title: '工作台',
          icon: 'Dashboard'
        }
      },
      {
        path: '/personal-center',
        name: 'PersonalCenter',
        component: () => import('@/views/PersonalCenter.vue'),
        meta: {
          title: '个人中心',
          icon: 'User'
        }
      },

      {
        path: '/stores',
        name: 'Stores',
        component: () => import('@/views/StoreManagement.vue'),
        meta: {
          title: '门店管理',
          icon: 'Shop'
        }
      },
      {
        path: '/warehouses',
        name: 'Warehouses',
        component: () => import('@/views/WarehouseManagement.vue'),
        meta: {
          title: '仓库管理',
          icon: 'Box'
        }
      },
      {
        path: '/materials',
        name: 'MaterialManagement',
        component: () => import('@/views/MaterialManagement.vue'),
        meta: { title: '材料管理' }
      },
      {
        path: '/product-categories',
        name: 'ProductCategoryManagement',
        component: () => import('@/views/ProductCategoryManagement.vue'),
        meta: { title: '产品分类管理' }
      },
      {
        path: '/material-categories',
        name: 'MaterialCategoryManagement',
        component: () => import('@/views/MaterialCategoryList.vue'),
        meta: { title: '材料分类管理' }
      },
      {
        path: '/kitchens',
        name: 'KitchenManagement',
        component: () => import('@/views/KitchenManagement.vue'),
        meta: { 
          title: '后厨管理',
          icon: 'House'
        }
      },
      {
        path: '/recipes',
        name: 'RecipeManagement',
        component: () => import('@/views/RecipeManagement.vue'),
        meta: { 
          title: '配方管理',
          icon: 'Document'
        }
      },
      {
        path: '/product-skus',
        name: 'ProductSkuManagement',
        component: () => import('@/views/ProductSkuManagement.vue'),
        meta: { 
          title: '产品SKU管理',
          icon: 'Goods'
        }
      },
      {
        path: '/product-boms',
        name: 'ProductBomManagement',
        component: () => import('@/views/ProductBomManagement.vue'),
        meta: { 
          title: '产品BOM管理',
          icon: 'List'
        }
      },
      {
        path: '/suppliers',
        name: 'SupplierManagement',
        component: () => import('@/views/SupplierManagement.vue'),
        meta: { 
          title: '供应商管理',
          icon: 'OfficeBuilding'
        }
      },
      // 生产管理模块路由
      {
        path: '/production/records',
        name: 'ProductionRecordManagement',
        component: () => import('@/views/production/ProductionRecordManagement.vue'),
        meta: {
          title: '生产记录管理',
          icon: 'Operation'
        }
      },
      {
        path: '/production/daily-reconciliation',
        name: 'DailyReconciliation',
        component: () => import('@/views/production/daily-reconciliation/DailyReconciliationList.vue'),
        meta: {
          title: '日对账记录',
          icon: 'Document'
        }
      },
      {
        path: '/production/daily-reconciliation/detail/:id',
        name: 'DailyReconciliationDetailProduction',
        component: () => import('@/views/reports/DailyReconciliationDetail.vue'),
        meta: {
          title: '日对账详情',
          hideInMenu: true
        }
      },

      // 库存管理模块路由
      {
        path: '/inventory/purchase-record',
        name: 'MaterialPurchaseRecord',
        component: () => import('@/views/inventory/MaterialPurchaseRecord.vue'),
        meta: {
          title: '材料采购记录',
          icon: 'ShoppingCart'
        }
      },
      {
        path: '/inventory/material',
        name: 'MaterialInventory',
        component: () => import('@/views/inventory/MaterialInventory.vue'),
        meta: {
          title: '材料库存管理',
          icon: 'Box'
        }
      },
      {
        path: '/inventory/product',
        name: 'ProductInventory',
        component: () => import('@/views/inventory/ProductInventory.vue'),
        meta: {
          title: '产品库存管理',
          icon: 'Box'
        }
      },
      {
        path: '/inventory/transactions',
        name: 'InventoryTransactions',
        component: () => import('@/views/inventory/InventoryTransactions.vue'),
        meta: {
          title: '库存流水记录',
          icon: 'List'
        }
      },
      {
        path: '/inventory/overview',
        name: 'InventoryOverview',
        component: () => import('@/views/inventory/InventoryOverview.vue'),
        meta: {
          title: '库存概览',
          icon: 'DataLine'
        }
      },
      {
        path: '/reports/daily-reconciliation',
        name: 'DailyReconciliationReport',
        component: () => import('@/views/reports/DailyReconciliationReport.vue'),
        meta: {
          title: '日对账报表',
          icon: 'Document'
        }
      },
      {
        path: '/reports/daily-reconciliation/:id',
        name: 'DailyReconciliationDetail',
        component: () => import('@/views/reports/DailyReconciliationDetail.vue'),
        meta: {
          title: '日对账详情',
          hideInMenu: true
        }
      },
      {
        path: '/reports/personal-daily-reconciliation',
        name: 'PersonalDailyReconciliation',
        component: () => import('@/views/reports/PersonalDailyReconciliation.vue'),
        meta: {
          title: '个人日对账',
          icon: 'User'
        }
      },
      {
        path: '/reports/historical-summary',
        name: 'HistoricalSummaryReport',
        component: () => import('@/views/reports/HistoricalSummaryReport.vue'),
        meta: {
          title: '历史汇总数据',
          icon: 'DataAnalysis'
        }
      },
      // 注释掉不存在的测试页面路由
      /*
      {
        path: '/test-daily-reconciliation',
        name: 'TestDailyReconciliation',
        component: () => import('@/views/TestDailyReconciliation.vue'),
        meta: {
          title: '日对账测试页面',
          hideInMenu: true
        }
      },
      {
        path: '/test-pagination-fixed',
        name: 'TestPaginationFixed',
        component: () => import('@/views/TestPaginationFixed.vue'),
        meta: {
          title: '分页栏固定效果测试',
          hideInMenu: true
        }
      },
      */
      {
        path: '/inventory/adjustments',
        name: 'InventoryAdjustments',
        component: () => import('@/views/inventory/InventoryAdjustmentRecords.vue'),
        meta: {
          title: '库存调整记录',
          icon: 'Edit'
        }
      },
      {
        path: '/inventory/loss-reason',
        name: 'LossReasonManagement',
        component: () => import('@/views/inventory/LossReasonManagement.vue'),
        meta: {
          title: '货损原因',
          icon: 'Warning'
        }
      },
      {
        path: '/inventory/loss-records',
        name: 'LossRecordManagement',
        component: () => import('@/views/inventory/LossRecordManagement.vue'),
        meta: {
          title: '报损记录管理',
          icon: 'Warning'
        }
      },
      {
        path: '/sales-record',
        name: 'SalesRecord',
        component: () => import('@/views/SalesRecordManagement.vue'),
        meta: { title: '销售记录', requiresAuth: true }
      },
      {
        path: '/custom-cake-order',
        name: 'CustomCakeOrder',
        component: () => import('@/views/CustomCakeOrderManagement.vue'),
        meta: { title: '定制蛋糕订单', requiresAuth: true }
      },
      {
        path: '/system',
        name: 'System',
        redirect: '/system/code-rules',
        meta: {
          title: '系统管理',
          icon: 'Setting'
        },
        children: [
          {
            path: '/system/code-rules',
            name: 'CodeRules',
            component: () => import('@/views/CodeRuleManagement.vue'),
            meta: {
              title: '编码规则',
              icon: 'Key'
            }
          },
          {
            path: '/system/staff',
            name: 'StaffManagement',
            component: () => import('@/views/StaffManagementNew.vue'),
            meta: {
              title: '人员管理',
              icon: 'User'
            }
          },
          {
            path: '/system/roles',
            name: 'RoleManagement',
            component: () => import('@/views/RoleManagementNew.vue'),
            meta: {
              title: '角色管理',
              icon: 'UserFilled'
            }
          },
          {
            path: '/system/permissions',
            name: 'PermissionManagement',
            component: () => import('@/views/PermissionManagement.vue'),
            meta: {
              title: '权限管理',
              icon: 'Lock'
            }
          },
          {
            path: '/system/modules',
            name: 'ModuleManagement',
            component: () => import('@/views/ModuleManagement.vue'),
            meta: {
              title: '模块管理',
              icon: 'Folder'
            }
          },
          {
            path: '/system/permission-test',
            name: 'PermissionTest',
            component: () => import('@/components/debug/PermissionTest.vue'),
            meta: {
              title: '权限测试',
              icon: 'Monitor'
            }
          },
          // 注释掉不存在的测试页面路由
          /*
          {
            path: '/system/test',
            name: 'SystemTest',
            component: () => import('@/views/SystemTest.vue'),
            meta: {
              title: '系统测试',
              icon: 'Monitor'
            }
          },
          {
            path: '/system/module-test',
            name: 'ModuleManagementTest',
            component: () => import('@/views/ModuleManagementTest.vue'),
            meta: {
              title: '模块管理测试',
              icon: 'Monitor'
            }
          },
          */
          {
            path: '/system/backup',
            name: 'SystemBackupManagement',
            component: () => import('@/views/SystemBackupManagement.vue'),
            meta: {
              title: '系统备份',
              icon: 'Download'
            }
          },
          {
            path: '/system/llm-config',
            name: 'LlmModelConfigManagement',
            component: () => import('@/views/LlmModelConfigManagement.vue'),
            meta: {
              title: '大模型配置',
              icon: 'Cpu'
            }
          },
          {
            path: '/system/integration',
            name: 'SystemIntegration',
            component: () => import('@/views/SystemIntegration.vue'),
            meta: {
              title: '系统对接',
              icon: 'Connection'
            }
          },
            {
              path: '/system/archive',
              name: 'Archive',
              redirect: '/system/archive/config',
              meta: {
                title: '会话存档',
                icon: 'ChatLineRound',
                permission: 'MOD0069' // 会话存档模块权限（整体控制）
              },
              children: [
                {
                  path: '/system/archive/config',
                  name: 'ArchiveConfig',
                  component: () => import('@/views/archive/ArchiveConfigManagement.vue'),
                  meta: {
                    title: '存档配置',
                    icon: 'Setting',
                    hideInMenu: true // 子路由不在菜单中显示，通过父路由控制
                  }
                },
                {
                  path: '/system/archive/chat-records',
                  name: 'ChatRecordManagement',
                  component: () => import('@/views/archive/ChatRecordManagement.vue'),
                  meta: {
                    title: '会话记录',
                    icon: 'Document',
                    hideInMenu: true // 子路由不在菜单中显示，通过父路由控制
                  }
                }
              ]
            }
        ]
      }
    ]
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue'),
    meta: {
      title: '页面不存在',
      hideInMenu: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta?.title) {
    document.title = `${to.meta.title} - 蛋糕进销存管理系统`
  }
  
  // 登录检查逻辑
  const token = localStorage.getItem('token')
  const userInfo = localStorage.getItem('userInfo')
  
  // 如果访问登录页面，直接允许
  if (to.path === '/login') {
    // 如果已经登录，重定向到首页
    if (token && userInfo) {
      next('/')
    } else {
      next()
    }
    return
  }
  
  // 检查是否需要认证
  if (to.meta?.requiresAuth !== false) {
    // 如果没有token或用户信息，重定向到登录页
    if (!token || !userInfo) {
      console.log('🔒 路由守卫：用户未登录，重定向到登录页')
      next('/login')
      return
    }
    
    // 验证token有效性（可选，可以调用后端API验证）
    try {
      const user = JSON.parse(userInfo)
      // 检查用户ID（可能是userId或staffId）
      const userId = user.userId || user.staffId
      if (!userId) {
        console.log('🔒 路由守卫：用户信息无效，重定向到登录页')
        console.log('🔒 路由守卫：用户对象:', user)
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        next('/login')
        return
      }
      console.log('✅ 路由守卫：用户信息验证通过，用户ID:', userId)
    } catch (error) {
      console.log('🔒 路由守卫：用户信息解析失败，重定向到登录页')
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      next('/login')
      return
    }
  }
  
  // 权限检查
  if (to.meta?.permission) {
    const hasPermission = canViewModule(to.meta.permission)
    if (!hasPermission) {
      console.log(`🔒 路由守卫：权限不足，无法访问 ${to.path} (需要权限: ${to.meta.permission})`)
      // 重定向到403页面或首页
      ElMessage.error('您没有权限访问该页面')
      next('/')
      return
    }
  }
  
  // 通过认证和权限检查，允许访问
  next()
})

export default router 